import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconClose(props: SvgIconProps) {
  return (
    <SVGIcon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="close-icon"
      {...props}
    >
      <path d="M14 4L4 14" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4 4L14 14" stroke="currentColor" strokeWidth="1.5" />
    </SVGIcon>
  );
}
